import { Reveal } from "./Reveal";

const MEMBERS = [
  {
    name: "Pranav Singhal",
    role: "Co-founder",
    credential: "B.Tech + M.Tech (Robotics), IIT Madras",
    bio: "Former Head, Avishkar Hyperloop & Global Hyperloop Competition. Experienced in successfully leading engineering projects.",
    photo: "/assets/team-pranav.png",
    testid: "team-card-pranav-singhal",
  },
  {
    name: "Nachiketh Grandhi",
    role: "Co-founder",
    credential: "B.Tech + M.Tech (EV), IIT Madras",
    bio: "Team Lead, SENAI Battery Simulations. 4+ years of experience in cell degradation modelling.",
    photo: "/assets/team-nachiketh.jpeg",
    testid: "team-card-nachiketh-grandhi",
  },
  {
    name: "Prof. Raghunathan Rengaswamy",
    role: "Mentor",
    credential: "Institute Chair Professor, IIT Madras",
    bio: "Former Dean of Global Engagement. Chemical Engineering & Data Science expert guiding the vision.",
    photo: "/assets/team-raghu.webp",
    testid: "team-card-raghunathan-rengaswamy",
  },
];

export const Team = () => (
  <section
    id="team"
    data-testid="team-section"
    className="py-20 sm:py-28 lg:py-32 border-t border-[#E2DFD7]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#2C4A3A] font-semibold">
          03 / Team
        </p>
        <h2 className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-[#121413] max-w-2xl">
          About Us.
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-[#4A4D4A]">
          We are a team of passionate inter-disciplinary engineers, looking to
          build control systems for the grids of the future.
        </p>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto">
        {MEMBERS.map((m, i) => (
          <Reveal key={m.testid} delay={i * 0.08}>
            <article
              data-testid={m.testid}
              className="group border border-[#E2DFD7] bg-[#FAF9F6] hover:border-[#2C4A3A] transition-colors duration-500"
            >
              <div className="relative aspect-square overflow-hidden bg-[#EFECE6]">
                <img
                  src={m.photo}
                  alt={`Portrait of ${m.name}`}
                  className="w-full h-full object-cover object-top saturate-[0.85] group-hover:saturate-100 group-hover:scale-[1.03] transition-all duration-700"
                />
                <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF9F6] bg-[#121413]/70 backdrop-blur-sm px-2 py-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-5 sm:p-6 border-t border-[#E2DFD7]">
                <h3 className="text-lg font-medium tracking-tight text-[#121413]">{m.name}</h3>
                <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-[#B86A28]">
                  {m.role}
                </p>
                <p className="mt-3 font-mono text-[11px] leading-relaxed text-[#2C4A3A]">
                  {m.credential}
                </p>
                <p className="mt-2.5 text-sm leading-relaxed text-[#4A4D4A]">{m.bio}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
